import { T_MongoDoc, T_MongoId } from "../types/_utils.types";
import { PaymentComponent } from "./payment.job.dto";

export enum TRANSACTION_STATUS {
  PROPOSED = "proposed",
  PENDING = "pending",
  PROCESSING = "processing",
  PAID = "paid",
  FAILED = "failed",
  CANCELLED = "cancelled",
  PAUSED = "paused",
  INDEFINITE_PAUSE = "indefinite_paused",
}

export enum DISBURSEMENT_STATUS {
  NONE = "none",
  UNPAID = "unpaid",
  PAID = "paid",
  APPROVED = "approved",
  CREDITED = "credited",
  WITHDRAWN = "withdrawn",
  REJECTED = "rejected",
  PROCESSING = "processing",
}

export enum TRANSACTION_TYPE {
  DEBIT = "debit",
  CREDIT = "credit",
  NONE = "none",
}

export enum LEDGER_CATEGORY {
  INITIAL = "initial",
  WEEKLY = "weekly",
  DAILY = "daily",
  MONTHLY = "monthly",
  ONETIME = "onetime",
  OTHER = "other",
  ADJUSTMENT = "adjustment",
  REFUND = "refund",
  SKIP = "skip",
}

export enum LOCK_STATUS {
  UNLOCKED = "unlocked",
  LOCKED = "locked",
  MODIFIED = "modified",
  TAMPERED = "tampered",
}

export enum DistributionType {
  /** Standard, fixed total and fixed interest */
  FIXED = "fixed",
  /** Percentage total and percentage interest */
  PERCENTAGE = "percentage",
  /** Percentage total but fixed interest */
  FIXED_INTEREST = "fixed_interest",
}

export type LedgerPaymentTracking = {
  program_fee_paid: boolean;
  legal_fee_paid: boolean;
  service_fee_paid: boolean;
  creditor_paid: boolean;
  full_payment_completed: boolean;
  component_paid: PaymentComponent | null;
  payment_attempt_id?: string;
  distribution_job_id?: string;
};

export type LedgerDto = {
  application_id: T_MongoId;
  debtor_id?: T_MongoId;
  dms_id?: string;
  transaction_type: TRANSACTION_TYPE;
  category: LEDGER_CATEGORY;
  week: number;
  amount: number;
  paid: number;
  status: TRANSACTION_STATUS;
  distribution_type: DistributionType;
  distribution: {
    program_fee: number;
    service_fee: number;
    legal_fee: number;
    creditor_total: number;
    final_creditor_total?: number;
  };
  distribution_percentage?: {
    total: number;
    program_fee?: number;
    creditor_fee?: number;
  };
  remaining_amount?: {
    total: number;
    program_fee: number;
    service_fee?: number;
    legal_fee?: number;
    creditor_fee: number;
  };
  creditors: {
    creditor_name: string;
    creditor_id: T_MongoId;
    linked_creditor_id?: string;
    dms_creditor_id?: string;
    amount: number;
    paid?: number;
    status: DISBURSEMENT_STATUS;
    disbursement_date?: Date;
    partner_creditor_id?: T_MongoId;
  }[];
  affiliates: {
    affiliate_id: T_MongoId;
    affiliate_plan: T_MongoId;
    amount: number;
    paid?: number;
    status: DISBURSEMENT_STATUS;
    disbursement_date?: Date;
  }[]; // array because there will be multi-level later on
  order_date: Date;
  posting_date?: Date;
  payment_date?: Date;
  lock: LOCK_STATUS;
  restructured_to?: number;
  payment_statuses?: {
    program_fee: number;
    service_fee: number;
    legal_fee: number;
    creditor_total: number;
  };
  fcds_collection?: {
    payment_date?: Date;
    amount_paid: number;
    expected_amount: number;
    remarks?: any;
  };
  creditor_collection?: {
    payment_date?: Date;
    amount_paid: number;
    expected_amount: number;
    remarks?: any;
  };
  note?: string;
  payment_tracking?: LedgerPaymentTracking;
  override_week_day_idx?: number;
};

export type LedgerSchemaDto = LedgerDto & T_MongoDoc;
export type CreateLedgerDto = LedgerDto;
export type UpdateLedger = Partial<LedgerDto>;

export enum PauseLedger {
  PAUSE_WHOLE_WEEK = "pause_whole_week",
  PAUSE_ALL_CREDITORS = "pause_all_creditors",
  PAUSE_CERTAIN_CREDITORS = "pause_certain_creditors",
  PAUSE_INDEFINITE = "pause_indefinite",
}
